const message = {
    defaultTitle: "KneUnion", indexLabel: "首页", overflowedIndicator: "更多"
};

export default message;